import { onUnmounted, watch } from 'vue'
import { MdTypography, MdModal, MdButton, MdSpinner } from '@antiqua-dls/vue-components'
import { disableScrollOnModalOpen } from 'src/utils/helper/misc'

export default {
  name: 'ConfirmPublishModal',
  components: {
    MdTypography,
    MdButton,
    MdModal,
    MdSpinner
  },
  props:{
    isModalOpen: {
      type: Boolean,
      default: false,
    },
    isBundleDiscarding: {
      type: Boolean,
      default: false,
    },
    modalId: {
      type: String,
      default: '',
    }
  },

  emits: ['confirm', 'closeModal'],


  setup(props){
    onUnmounted(() => {
      disableScrollOnModalOpen(false)
    })

    watch(() => props.isModalOpen, () => {
      disableScrollOnModalOpen(props.isModalOpen)
    })

    return {
    }
  }
}
